<template>
  <div class="listingsfilter bg-beige bg-md-white">
    <div class="container">
      <div class="bg-beige pt-2 pb-md-3 px-md-2 d-flex flex-wrap">
        <div v-if="filteredFilters" v-for="filter in filteredFilters" class="filter-button-wrapper">
          <p class="mb-0">{{ filter.title }}</p>
          <div :class="filter.name.replace('_', '-')">
            <buttons :config="filter" v-on:button-select="filterChanged"></buttons>
          </div>
        </div>
        <searchInput v-if="filteredFilters" v-on:search-change="filterChanged" :noItems="noItems"></searchInput>
        <div class="w-100">
          <a href="/nyproduktion/" class="text-turquoise">Till vår nyproduktion <span class="link__arrow d-inline"></span></a>
        </div>
      </div>
      <div class="d-flex justify-content-center pb-5 pb-md-0 pt-md-3">
        <button class="link__background col col-md-auto wide first-button" :class="activeView === 'list' ? '' : 'white'" v-on:click="changeView('list')">Visa som lista</button>
        <button class="link__background col col-md-auto wide" :class="activeView === 'map' ? '' : 'white'" v-on:click="changeView('map')">Visa på karta</button>
      </div>
    </div>
  </div>
</template>
<script>

import searchInput from './searchInput';
import buttons from './button';

export default {
  components: {
    searchInput,
    buttons,
  },
  props: {
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    search: {
      default: 0,
    },
  },
  data: function() {
    return {
      filename: 'filters',
      filteredFilters: [],
      filterValues:
          {
            object_type: [],
            object_area: [],
            search: '',
          },
      searchInput: '',
      noItems: 0,
      activeView: 'list',
      urlParams: new URLSearchParams(window.location.search),
    };
  },
  methods: {
    filter: function() {
    },
    filterChanged: function(data) {
      //event search-changed or button-select caught
      if (data.name) {
        this.filterValues[data.name] = data.value;
      }
      Event.fire('listings-filter', this.filterValues); //Fire listing-filter event (this is global)
      // Check if number of items is empty or not.
      Event.listen('listings-no-items', (numberOfItems) => {
        if (numberOfItems === 0) {
          this.noItems = 1;
        } else {
          this.noItems = 0;
        }
      });
    },
    initialItems: function(items) {
      if (this.filters.length > 0 ) {
        this.filters.forEach((filter) => {
          //Dont show object_area-option if no object has it
          filter.options = _.filter(filter.options, function(option) {
            return option;
          });
          this.filteredFilters.push(filter);
        });
      }
      //Trigger the event.
      Event.fire('listings-filter', this.filterValues); //Fire listing-filter event (this is global)
    },
    changeView: function (event) {
      const value = event;

      if (value == '') {
        this.urlParams.delete('view');
      } else {
        this.urlParams.set('view', value);
      }

      this.activeView = value;
      Event.fire('listings-view', value); //Fire listing-filter event (this is global)

      window.history.replaceState(null, null, '?' + this.urlParams.toString());
    },
  },
  mounted: function() {
    Event.listen('listings-initial-items', (items) => this.initialItems(items));

    if (this.urlParams.get('view')) {
      this.changeView(this.urlParams.get('view'));
    }
  },

};
</script>

<style>
.first-button {
  margin-right: 1.5%;
}
</style>
